import { IUser } from '@sdk/contracts';
import { Empty } from 'antd';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SpinnerWrapper,
  SubscriptionsWrapper,
  TableWrapper,
  Wrapper
} from './StudentTracking.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { StudyStatus } from '@/components/StudyStatus';
import { TagItem } from '@/components/TagItem';
import { useMySubscriptions, useStudentSubscriptions } from '@/store';

type Props = {
  student: IUser;
};

export const StudentTracking: React.FC<Props> = ({ student }) => {
  const { t } = useTranslation();
  const { subscriptions, isLoading } = useStudentSubscriptions(student._id);
  const { selectedSubscription, setSelectedSubscription } = useMySubscriptions();

  useEffect(() => {
    if (subscriptions?.length) setSelectedSubscription(subscriptions[0]);
  }, [subscriptions]);

  if (isLoading)
    return (
      <SpinnerWrapper>
        <LoadingCircleSpinner />
      </SpinnerWrapper>
    );

  if (isEmpty(subscriptions))
    return <Empty description={t('THERE_ARE_NOT_COURSES_ASOCIATED_TO_THIS_USER')} />;

  return (
    <Wrapper>
      <SubscriptionsWrapper>
        {subscriptions?.map(subscription => (
          <TagItem
            name={subscription.course.name}
            key={subscription._id}
            progress={subscription.progress}
            isChecked={subscription._id === selectedSubscription?._id}
            onClick={() => setSelectedSubscription(subscription)}
          />
        ))}
      </SubscriptionsWrapper>
      <TableWrapper>
        <StudyStatus />
      </TableWrapper>
    </Wrapper>
  );
};
